module.exports = __webpack_public_path__ + "img/ywcgq.b55c5b9b.png";